import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { ListCategoriesComponent } from './list/list-categories/list-categories.component';
import { SubscriberCreateComponent } from './subscriber/subscriber-create/subscriber-create.component';
import { ListMembersComponent } from './list/list-members/list-members.component';

export const mailchimpRoutes: Routes = [
  {
    path: 'mailchimp',
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'list/:listId/create',
        component: SubscriberCreateComponent
      },
      {
        path: 'list/:listId/edit',
        component: ListMembersComponent
      },
      {
        path: 'list/:listId/:subscriberId/edit',
        component: SubscriberCreateComponent
      },
      {
        path: 'subscriber/create',
        component: SubscriberCreateComponent
      },
      {
        path: '',
        component: ListCategoriesComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/mailchimp/mailchimp.routes.ts